<template>
  <footer class="login_bg">
    <!-- <div class="content">
      <span class="line"></span>
        <span class="title">
        客戶服務
        </span>
      <span class="line"></span>
      </div>
      <div>
        <ul>
          <li>服務電話:(02)2578-2626#327/219</li>
          <li class="none">|</li>
          <li>客服時間:週一至週五 09:00 ~ 18:00</li>
          <li class="none">|</li>
          <li>客服信箱:326@liveabc.com</li>
        </ul>
      </div> -->
      <p>Copyright@Heborn Soft Limited. All Rights Reserved</p>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .login_bg {
    background-color: #aeb2fa;
    color: #ffffff;
    padding-top: 1rem;
    width: 100%;
    .content,p,ul {
      text-align: center;
      padding-bottom: 1rem;
      margin: 0;
    }
    .line {
      display: inline-block;
      width: 30vw;
      border-top: 1px solid #ffffff;
    }
    .title {
      margin: 1rem;
      width: 80%;
      font-family: Microsoft JhengHei;
      font-weight:bold;
      font-size: 1rem;
      vertical-align: -4px;
    }
    @media screen and (min-width: 600px){
      ul {
        display: flex;
        justify-content:center;
      }
      .none{
        display: block !important;
      }
    }
    li {
      font-size: 1rem;
      list-style:none;
      margin: 10px 20px;
    }
    .none {
      display: none;
    }
  }
</style>
